// extracted by mini-css-extract-plugin
export default {"autoCompleteWrapper":"styles_autoCompleteWrapper__DKPag","autoCompleteBase":"styles_autoCompleteBase__VW2I4"};